<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div :class="{'mt-1': depth == 0}">
          <div
            class="row"
            :class="{'ml-2':(!menuItem.hasOwnProperty('child') && menuItem.menuType != 'Readings')}"
          >
            <div class="col-1 p-2" v-if="menuItem.menuType == 'Readings'">
              <i v-if="menuItem.meter.Removed" class="far fa-dot-circle danger"></i>
              <i v-else class="far fa-dot-circle success"></i>
            </div>
            <div
              class="col-1 p-2 pointer"
              v-if="menuItem.hasOwnProperty('icon')"
              @click="toggleChildren()"
            >
              <span id="chevron-open" v-if="open" class="fa-sm fas fa-chevron-down"></span>
              <span id="chevron-closed" v-else class="fa-sm" :class="menuItem.icon"></span>
            </div>

            <div
              :id="'_' + menuItem.title.replace(/[\s\-\.]/g, '')"
              class="col-11 p-2"
              :class="{'selected':(isActive), 'pointer': menuItem.pointer, 'cursor-default': !menuItem.pointer}"
              @click="selectItem(menuItem)"
            >
              <span>{{menuItem.title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="menu-item-child ml-3" v-if="open && menuItem.hasOwnProperty('child')">
      <div v-for="(childItem, index) in menuItem.child" :key="index">
        <menu-item
          :menuItem="childItem"
          :menu="menu"
          :depth="depth + 1"
          :isCollapsed="isCollapsed"
          :isOpen="expand"
          :expandAll="expand"
          @item-selected="childSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  props: {
    menuItem: {
      Type: Object,
      required: true,
    },
    menu: {
      Type: Array,
    },
    depth: {
      Type: Number,
      default: 0,
    },
    isCollapsed: {
      Type: Boolean,
    },
    isOpen: {
      Type: Boolean,
    },
    expandAll: {
      Type: Boolean,
    },
  },
  data() {
    return {
      open: this.isOpen,
      expand: this.expandAll,
    };
  },
  computed: {
    isActive() {
      if (this.menuItem.menuType == "Readings") {
        return (
          this.menuItem.meter.Serial == this.activeMeter.Serial &&
          (this.menuItem.meter.Mprn == this.activeMeter.Mprn ||
            this.menuItem.meter.Mpan == this.activeMeter.Mpan)
        );
      } else {
        if (this.activeSection == "Contract") {
          return (
            this.menuItem.hasOwnProperty("contract") &&
            this.menuItem.contract.Id == this.activeContract.Id
          );
        }
        if (this.activeSection == "ServiceBundle") {
          return (
            this.menuItem.hasOwnProperty("serviceBundle") &&
            this.menuItem.serviceBundle.Id == this.activeBundle.Id
          );
        }
        if (
          this.activeSection == "GasService" ||
          this.activeSection == "ElectricityService"
        ) {
          return (
            this.menuItem.hasOwnProperty("service") &&
            this.menuItem.service.ServiceIdentifier ==
              this.activeService.ServiceIdentifier &&
            this.menuItem.contractId == this.activeContract.Id
          );
        }
        if (this.activeSection == "CommercialConfig") {
          return (
            this.menuItem.hasOwnProperty("commercialConfig") &&
            this.menuItem.commercialConfig.Id == this.activeCommercialConfig.Id
          );
        }
      }
    },
    activeMeter() {
      return this.$store.state.meters.activeMeter;
    },
    activeBundle() {
      return this.$store.state.contracts.activeBundle;
    },
    activeService() {
      return this.$store.state.contracts.activeService;
    },
    activeCommercialConfig() {
      return this.$store.state.contracts.activeCommercialConfig;
    },
    activeContract() {
      return this.$store.state.contracts.activeContract;
    },
    activeSection() {
      return this.$store.state.contracts.activeSection;
    },
  },
  mounted() {
    this.expand = false;
  },
  methods: {
    selectItem(item) {
      let items = [];
      items.push(item);
      this.$emit("item-selected", items);
    },
    toggleChildren() {
      this.open = !this.open;
    },
    childSelected(items) {
      items.push(this.menuItem);
      this.$emit("item-selected", items);
    },
  },
};
</script>
